import React, {useState, useEffect} from "react";
import {GraphState, DataUnit} from "../../types";
import Chart from "react-google-charts";
import {autorun} from "mobx";
import {Typography} from "@material-ui/core";

export const AreaChart = (p: {graph: GraphState; filteredData: DataUnit[]}) => {
    const filteredData = p.filteredData;
    const dt = p.graph.dataTypes;
    const processedData = [
        [dt.x.value, ...dt.y.filter(y => y.isEnabled).map(y => y.label)],
        ...filteredData.map(du => [du.x, ...du.y])
    ];

    return processedData.length > 1 ? (
        <Chart
            style={{display: "flex", justifyContent: "center", width: "100%"}}
            chartType="AreaChart"
            loader={<div>Loading Chart</div>}
            data={processedData}
            options={{
                // title: p.graph.title || `${xAxisLabel} by ${yAxisLabel}`,
                legend: p.graph.legend,
                chartArea: {left: 40, right: 10, top: 10}
            }}
            formatters={[
                {
                    type: "DateFormat",
                    column: 0,
                    options: {
                        formatType: "short"
                    }
                }
            ]}
            legendToggle
        />
    ) : (
        <div style={{height: "100%", width: "100%", display: "grid", placeItems: "center"}}>
            <Typography variant="subtitle2">{"NO DATA"}</Typography>
        </div>
    );
};
